// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-container div.p-dropdown,
.filter-container div.p-multiselect {
    background: rgb(255, 255, 255, 0.09);
    margin: 8px 8px 8px 0;
}
.filter-container div.p-dropdown .p-dropdown-label,
.filter-container div.p-multiselect .p-multiselect-label{
    color: rgba(255, 255, 255, 0.5);
}

.filter-container div.p-dropdown .p-dropdown-label{
    font-size: 12px;
    font-weight: 300;
    text-align: left;
}
.filter-container div.p-dropdown:not(.p-disabled).p-focus,
.filter-container div.p-dropdown:not(.p-disabled):hover,
.filter-container .p-multiselect:not(.p-disabled).p-focus,
.filter-container div.p-multiselect:hover {
    background: var(--blue-dark);
    border-color: rgba(255, 255, 255, 0.34);
    box-shadow: none;
}
.filter-container div.p-multiselect {
    /*padding: 8px;*/
    height: fit-content;
    font-size: 12px;
    font-weight: 300;
    text-align: left;
    border: 1px solid  rgba(255, 255, 255, 0.34);
}
.filter-container div.p-dropdown .p-icon,
.filter-container div.p-multiselect .p-icon {
    width: 8px;
    height: 8px;
    color: var(--blue);
}

.panel-filter-multiselect.p-multiselect-panel .p-multiselect-header,
.panel-filter-multiselect.p-multiselect-panel {
    background: var(--blue-dark);
    border: 1px solid rgba(255, 255, 255, 0.34);
}
.panel-filter-dropdown.p-dropdown-panel .p-dropdown-items-wrapper .p-dropdown-items .p-dropdown-item,
.panel-filter-multiselect.p-multiselect-panel .p-multiselect-items-wrapper .p-multiselect-item {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.5);
}

.filter-container .p-multiselect.p-multiselect-chip .p-multiselect-token {
    background: var(--blue-dark);
    border: 1px solid var(--blue);
    color: var(--blue);
}
.panel-filter-dropdown.p-dropdown-panel .p-dropdown-items-wrapper .p-dropdown-items .p-dropdown-item:focus,
.panel-filter-multiselect.p-multiselect-panel .p-multiselect-items .p-multiselect-item:focus{
    box-shadow: none;
}

.panel-filter-multiselect.p-multiselect-panel .p-multiselect-items .p-multiselect-item:not(.p-highlight):not(.p-disabled):hover{
    color: var(--blue);
    box-shadow: none;
    background: inherit;
}
/*.panel-filter-dropdown.p-dropdown-panel .p-dropdown-items-wrapper .p-dropdown-items.p-highlight,*/
.panel-filter-dropdown.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight,
.panel-filter-multiselect.p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight {
    text-decoration: underline;
    box-shadow: none;
    background: inherit;
    color: var(--blue);
}

/*.panel-filter-multiselect.p-multiselect-panel .p-multiselect-header .p-checkbox,*/
.panel-filter-multiselect.p-multiselect-panel .p-multiselect-items-wrapper .p-checkbox {
    display: none;
}

.mimetika-dropdown{
    border-color: rgba(255, 255, 255, 0.34);
}
.mimetika-dropdown .p-hidden-accessible.p-dropdown-hidden-select{
    display: none;
}
/* Responsive styles */
@media (max-width: 375px) {
    .panel-filter-dropdown input.p-inputtext {
        padding: 4px !important;
    }
}

`, "",{"version":3,"sources":["webpack://./src/css/form-filter.css"],"names":[],"mappings":"AAAA;;IAEI,oCAAoC;IACpC,qBAAqB;AACzB;AACA;;IAEI,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;;;;IAII,4BAA4B;IAC5B,uCAAuC;IACvC,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,4CAA4C;AAChD;AACA;;IAEI,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA;;IAEI,4BAA4B;IAC5B,2CAA2C;AAC/C;AACA;;IAEI,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,kBAAkB;AACtB;AACA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;AACA,mGAAmG;AACnG;;IAEI,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,mFAAmF;AACnF;IACI,aAAa;AACjB;;AAEA;IACI,uCAAuC;AAC3C;AACA;IACI,aAAa;AACjB;AACA,sBAAsB;AACtB;IACI;QACI,uBAAuB;IAC3B;AACJ","sourcesContent":[".filter-container div.p-dropdown,\n.filter-container div.p-multiselect {\n    background: rgb(255, 255, 255, 0.09);\n    margin: 8px 8px 8px 0;\n}\n.filter-container div.p-dropdown .p-dropdown-label,\n.filter-container div.p-multiselect .p-multiselect-label{\n    color: rgba(255, 255, 255, 0.5);\n}\n\n.filter-container div.p-dropdown .p-dropdown-label{\n    font-size: 12px;\n    font-weight: 300;\n    text-align: left;\n}\n.filter-container div.p-dropdown:not(.p-disabled).p-focus,\n.filter-container div.p-dropdown:not(.p-disabled):hover,\n.filter-container .p-multiselect:not(.p-disabled).p-focus,\n.filter-container div.p-multiselect:hover {\n    background: var(--blue-dark);\n    border-color: rgba(255, 255, 255, 0.34);\n    box-shadow: none;\n}\n.filter-container div.p-multiselect {\n    /*padding: 8px;*/\n    height: fit-content;\n    font-size: 12px;\n    font-weight: 300;\n    text-align: left;\n    border: 1px solid  rgba(255, 255, 255, 0.34);\n}\n.filter-container div.p-dropdown .p-icon,\n.filter-container div.p-multiselect .p-icon {\n    width: 8px;\n    height: 8px;\n    color: var(--blue);\n}\n\n.panel-filter-multiselect.p-multiselect-panel .p-multiselect-header,\n.panel-filter-multiselect.p-multiselect-panel {\n    background: var(--blue-dark);\n    border: 1px solid rgba(255, 255, 255, 0.34);\n}\n.panel-filter-dropdown.p-dropdown-panel .p-dropdown-items-wrapper .p-dropdown-items .p-dropdown-item,\n.panel-filter-multiselect.p-multiselect-panel .p-multiselect-items-wrapper .p-multiselect-item {\n    font-size: 12px;\n    color: rgba(255, 255, 255, 0.5);\n}\n\n.filter-container .p-multiselect.p-multiselect-chip .p-multiselect-token {\n    background: var(--blue-dark);\n    border: 1px solid var(--blue);\n    color: var(--blue);\n}\n.panel-filter-dropdown.p-dropdown-panel .p-dropdown-items-wrapper .p-dropdown-items .p-dropdown-item:focus,\n.panel-filter-multiselect.p-multiselect-panel .p-multiselect-items .p-multiselect-item:focus{\n    box-shadow: none;\n}\n\n.panel-filter-multiselect.p-multiselect-panel .p-multiselect-items .p-multiselect-item:not(.p-highlight):not(.p-disabled):hover{\n    color: var(--blue);\n    box-shadow: none;\n    background: inherit;\n}\n/*.panel-filter-dropdown.p-dropdown-panel .p-dropdown-items-wrapper .p-dropdown-items.p-highlight,*/\n.panel-filter-dropdown.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight,\n.panel-filter-multiselect.p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight {\n    text-decoration: underline;\n    box-shadow: none;\n    background: inherit;\n    color: var(--blue);\n}\n\n/*.panel-filter-multiselect.p-multiselect-panel .p-multiselect-header .p-checkbox,*/\n.panel-filter-multiselect.p-multiselect-panel .p-multiselect-items-wrapper .p-checkbox {\n    display: none;\n}\n\n.mimetika-dropdown{\n    border-color: rgba(255, 255, 255, 0.34);\n}\n.mimetika-dropdown .p-hidden-accessible.p-dropdown-hidden-select{\n    display: none;\n}\n/* Responsive styles */\n@media (max-width: 375px) {\n    .panel-filter-dropdown input.p-inputtext {\n        padding: 4px !important;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
